/* @license react-google-recaptcha-ultimate v1.2.2 */
import t from"react";import{GoogleReCaptchaContext as o}from"./GoogleReCaptchaContext.js";var r=function(){return t.useContext(o)};export{r as useGoogleReCaptcha};
//# sourceMappingURL=useGoogleReCaptcha.js.map
